import fetch from '../utils/fetch';

// 短信发送接口（移动端)
export function sendVerifyCodeWithActionCode(data) {
  const postData = {
    content: '【御家微商城】，您收到的验证码为：{$verifyCode},请勿泄露给其他人',
    ...data,
  };
  return fetch.post(`/sms/api/smsApp/sendVerifyCodeWithActionCode`, postData);
}
// 判断网易行为码是否开启
export function izEnableWangyiActionCode() {
  return fetch.get(`/sms/api/smsApp/izEnableWangyiActionCode`);
}
